import Cookies from 'js-cookie';

/**
 * Not using the string 'token' directly here since this would be visible in browser console.
 * It's not adding anything to security but not being too explicit here.
 */
const AUTH_TOKEN_KEY = '__id';

export const getStoredToken = () => Cookies.get(AUTH_TOKEN_KEY);

export const removeStoredToken = () => Cookies.remove(AUTH_TOKEN_KEY);

export const storeToken = (token) => {
    /**
     * 30 minutes should be enough for an expert to explore the Adobe Sign platform,
     * go through the terms of participation, read and sign it, and redirected back to the
     * form without having to enter the login code again.
     */
    const inThirtyMinutes = new Date(Date.now() + 30 * 60 * 1000);
    Cookies.set(AUTH_TOKEN_KEY, token, {
        expires: inThirtyMinutes,
    });
};
